/* eslint-disable react/jsx-wrap-multilines */
import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Select from 'react-select';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import { get } from 'session';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import * as actions from '../action';
import * as c from '../constant';
import BuvContent from './BuvContent';
import BuvModal from '../modal/BuvModal';

const form = {
  keyword: '',
};

function BuvContainer({
  match,
  history,
  getBuvList,
  buvList,
  isLoading,
  removeBuv,
  buvListPager,
  getSingleBuv,
  getDistrictList,
  districtList,
  ordinanceRevisionId,
  clearItem,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);
  const [district, setDistrict] = useState({
    label: '',
    value: 0,
  });

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BuvModal type="NEW" ordinanceRevisionId={ordinanceRevisionId} />
      ),
      title: 'Add Base Unit Value',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <BuvModal
          type="EDIT"
          updateList={data.attributes}
          buvId={data.id}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Base Unit Value',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this base unit value?',
      () => {
        removeBuv(data.id, () => {
          getBuvList({
            isPaginate: 1,
            ordinance_revision_id: ordinanceRevisionId,
          });
          const id = _.get(buvList, '0.id');
          if (id !== data.id) {
            history.push(`${id}`);
            getSingleBuv(id);
          } else {
            window.location.pathname = '/rpt/land/land-settings/buv';
            history.replace({
              pathname: '/rpt/land/land-settings/buv',
            });
          }
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const createDropdown = (list) => {
    const newList = [];
    list.map((data) => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  const handleChangeSelect = (e) => {
    setDistrict(e);
    getBuvList({
      rptax_district_id: e.value,
      isPaginate: 1,
      ordinance_revision_id: ordinanceRevisionId,
    });
  };

  useEffect(() => {
    getBuvList(
      { isPaginate: 1, ordinance_revision_id: ordinanceRevisionId },
      (res) => {
        const id = _.get(res, 'data.0.id');
        if (id) {
          history.push(`/rpt/land/land-settings/buv/${id}`);
          getSingleBuv(id);
        } else clearItem(c.GET_SINGLE_BUV, {});
      }
    );
    getDistrictList({ isPaginate: 1 });
    return () => {
      setModal({ isOpen: false });
    };
  }, [ordinanceRevisionId]);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc',
    isPaginate: 1,
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getBuvList({
        isPaginate: 1,
        q: formData.keyword,
        ordinance_revision_id: ordinanceRevisionId,
      });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  const token = get('token') || '';

  const [file, setFile] = useState({});

  const fileHandler = (e) => {
    setFile(e.target.files[0]);
  };

  const postFormData = (url) => (formdata, onProgress) =>
    new Promise((resolve, reject) => {
      try {
        const xhr = new XMLHttpRequest();
        xhr.timeout = 300000;
        // eslint-disable-next-line no-unused-vars
        xhr.addEventListener('timeout', (e) =>
          resolve({
            status: 400,
            message: 'Request Timeout, Please try again.',
          })
        );
        xhr.open('POST', url);
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        xhr.onload = () => {
          try {
            const jsonResponse = JSON.parse(xhr.response);
            const response = {
              status: xhr.status, // jsonResponse.status,
              data: jsonResponse,
            };
            resolve(response);
          } catch (err) {
            reject(err);
          }
        };
        xhr.onerror = () => {
          const errRes = {
            data: false,
            message: 'Oops..Something went wrong.',
          };
          Alert.error(errRes);
          return resolve(errRes);
        };
        if (xhr.upload) {
          xhr.upload.onprogress = (evt) => {
            if (evt.lengthComputable) {
              const progress = Math.ceil((evt.loaded / evt.total) * 100);
              if (onProgress) {
                onProgress(progress);
              }
            }
          };
        }
        xhr.send(formdata);
      } catch (err) {
        reject(err);
      }
    });

  const onUploadFile = async (e) => {
    e.preventDefault();

    const data = new FormData();
    try {
      data.append('file', file);
      data.append('subject', 'LAND_BASIC_UNIT_VALUE');
      const res = await postFormData(
        `${process.env.REACT_APP_WS}api/v1/rpt/administrator/settings/csv_imports`
      )(data);
      if (_.get(res, 'status') === 200) {
        Alert.success(_.get(res, 'data.message'));
        getBuvList({
          isPaginate: 1,
          ordinance_revision_id: ordinanceRevisionId,
        });
      }
      if (_.get(res, 'status') === 422) {
        Alert.error(_.get(res, 'data.message'));
      }
      if (_.get(res, 'status') === 400) {
        const message = _.get(res, 'data.errors.0.detail');
        Alert.error(message);
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err, 'err');
    }
  };

  return (
    <div className="card-content-listing">
      <div className="ml-auto row-nav">
        <div className="float-left">
          <div className="form-group">
            {isLoading && (
              <button
                disabled
                type="button"
                className="btn btn-light btn-round border border-primary font-weight-bold px-4 ml-auto"
              >
                <i className="fa fa-spin fa-spinner" />
              </button>
            )}
          </div>
        </div>
        <div className="float-right">
          <div className="form-group">
            {!isLoading && (
              <input
                type="file"
                className="btn btn-link input-upload"
                onChange={fileHandler}
              />
            )}
          </div>
        </div>
        <div className="flow-right">
          <div className="form-group">
            <button
              type="button"
              onClick={onUploadFile}
              className="ml-2 btn btn-link button-upload"
            >
              Upload
            </button>
          </div>
        </div>
      </div>
      <div className="p-0 mb-3 mt-3">
        <div className="container-fluid  px-0">
          <div className="d-inline w-auto d-flex justify-content-start m-3">
            <label className="label-transaction-card mb-0 d-flex align-items-center mr-3">
              Select District:
            </label>
            <div style={{ width: 250 }}>
              <Select
                styles={customStyle}
                placeholder="Select District"
                value={district}
                options={createDropdown(districtList)}
                onChange={handleChangeSelect}
              />
            </div>
          </div>
        </div>
      </div>
      <Route
        path={`${match.path}/:buvId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Basic Unit Values"
            getData={getBuvList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:buvId?`}
            listName="Buvs"
            label="Buvs"
            renderItem={(item) => (
              <div className="p-3">
                <div className="transaction-list-company">
                  {_.get(item, 'attributes.rptax_location_name')}
                </div>
                <h4 className="mt-1 mb-0 transaction-list-name">
                  {' '}
                  {_.get(item, 'attributes.street_from')} -{' '}
                  {_.get(item, 'attributes.street_to')}{' '}
                </h4>
              </div>
            )}
            isLoading={isLoading}
            selected={params.buvId}
            data={buvList}
            dataPager={buvListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:buvId?`}
                    render={() => (
                      <BuvContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:buvId?`}
                  render={() =>
                    !params.buvId && buvList.length > 0 ? (
                      <Redirect to={`${match.url}/${_.get(buvList, '0.id')}`} />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BuvContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBuvList: PropTypes.instanceOf(Function).isRequired,
  buvList: PropTypes.instanceOf(Array).isRequired,
  buvListPager: PropTypes.instanceOf(Object).isRequired,
  removeBuv: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getSingleBuv: PropTypes.instanceOf(Function).isRequired,
  getDistrictList: PropTypes.instanceOf(Function).isRequired,
  districtList: PropTypes.instanceOf(Array).isRequired,
  clearItem: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  buvList: _.get(api, `${c.GET_BUV}.list`) || [],
  districtList: _.get(api, `${c.GET_DISTRICT_LIST}.list`) || [],
  buvListPager: _.get(api, `${c.GET_BUV}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_BUV) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BuvContainer);
